function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ContextActions } from '@deephaven/components';
import { CommandHistory, SHORTCUTS } from '@deephaven/console';
import Log from '@deephaven/log';
import { getCommandHistoryStorage } from '@deephaven/redux';
import { assertNotNull, Pending } from '@deephaven/utils';
import { ConsoleEvent, NotebookEvent } from "../events/index.js";
import "./CommandHistoryPanel.css";
import Panel from "./CorePanel.js";
import { getDashboardSessionWrapper } from "../redux/index.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('CommandHistoryPanel');
class CommandHistoryPanel extends Component {
  static handleError(error) {
    log.error(error);
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "pending", void 0);
    this.handleFocusHistory = this.handleFocusHistory.bind(this);
    this.handleSessionOpened = this.handleSessionOpened.bind(this);
    this.handleSessionClosed = this.handleSessionClosed.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSendToConsole = this.handleSendToConsole.bind(this);
    this.handleSendToNotebook = this.handleSendToNotebook.bind(this);
    this.container = /*#__PURE__*/React.createRef();
    this.pending = new Pending();
    var session = props.session,
      sessionId = props.sessionId,
      language = props.language;
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      panelState: {},
      session,
      sessionId,
      language,
      contextActions: [{
        action: this.handleFocusHistory,
        shortcut: SHORTCUTS.COMMAND_HISTORY.FOCUS_HISTORY
      }]
    };
  }
  componentDidMount() {
    var _this$props = this.props,
      glEventHub = _this$props.glEventHub,
      session = _this$props.session;
    glEventHub.on(ConsoleEvent.FOCUS_HISTORY, this.handleFocusHistory);
    if (session != null) {
      this.loadTable();
    }
  }
  componentWillUnmount() {
    var glEventHub = this.props.glEventHub;
    glEventHub.off(ConsoleEvent.FOCUS_HISTORY, this.handleFocusHistory);
    this.pending.cancel();
  }
  handleFocusHistory() {
    if (this.container.current) {
      this.container.current.focus();
    }
  }
  handleShow() {
    var _this$container$curre;
    // virtual list requires a forced reset to scroll position when picked up and dropped in same place
    (_this$container$curre = this.container.current) === null || _this$container$curre === void 0 || _this$container$curre.restoreScrollPosition();
  }
  handleSessionOpened(_ref) {
    var session = _ref.session,
      language = _ref.language,
      sessionId = _ref.sessionId;
    this.setState({
      session,
      sessionId,
      language
    }, () => {
      this.loadTable();
    });
  }
  handleSessionClosed() {
    this.pending.cancel();
    this.setState({
      session: undefined,
      language: undefined,
      table: undefined
    });
  }
  handleSendToNotebook(settings) {
    var forceNewNotebook = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _this$state = this.state,
      session = _this$state.session,
      language = _this$state.language;
    log.debug('handleSendToNotebook', session, settings);
    if (!session) {
      log.error('Session is not connected.');
      return;
    }
    var glEventHub = this.props.glEventHub;
    glEventHub.emit(forceNewNotebook ? NotebookEvent.CREATE_NOTEBOOK : NotebookEvent.SEND_TO_NOTEBOOK, session, language, settings);
  }
  handleSendToConsole(command) {
    var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var execute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    log.debug('handleSendToConsole', command);
    var glEventHub = this.props.glEventHub;
    glEventHub.emit(ConsoleEvent.SEND_COMMAND, command, focus, execute);
  }
  loadTable() {
    var commandHistoryStorage = this.props.commandHistoryStorage;
    var _this$state2 = this.state,
      language = _this$state2.language,
      sessionId = _this$state2.sessionId;
    assertNotNull(language);
    assertNotNull(sessionId);
    this.pending.add(commandHistoryStorage.getTable(language, sessionId, Date.now()), resolved => resolved.close()).then(table => {
      this.setState({
        table
      });
    }).catch(CommandHistoryPanel.handleError);
  }
  render() {
    var _this$props2 = this.props,
      glContainer = _this$props2.glContainer,
      glEventHub = _this$props2.glEventHub,
      commandHistoryStorage = _this$props2.commandHistoryStorage;
    var _this$state3 = this.state,
      language = _this$state3.language,
      contextActions = _this$state3.contextActions,
      table = _this$state3.table;
    return /*#__PURE__*/_jsxs(Panel, {
      className: "command-history-pane",
      componentPanel: this,
      glContainer: glContainer,
      glEventHub: glEventHub,
      onSessionOpen: this.handleSessionOpened,
      onSessionClose: this.handleSessionClosed,
      onShow: this.handleShow,
      children: [!table && /*#__PURE__*/_jsx("div", {
        className: "command-history-disconnected-message",
        children: "Waiting for console connection"
      }), table && language != null && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(CommandHistory, {
          ref: this.container,
          language: language,
          sendToNotebook: this.handleSendToNotebook,
          sendToConsole: this.handleSendToConsole,
          table: table,
          commandHistoryStorage: commandHistoryStorage
        }), /*#__PURE__*/_jsx(ContextActions, {
          actions: contextActions
        })]
      })]
    });
  }
}
_defineProperty(CommandHistoryPanel, "COMPONENT", 'CommandHistoryPanel');
_defineProperty(CommandHistoryPanel, "TITLE", 'Command History');
var mapStateToProps = (state, ownProps) => {
  var commandHistoryStorage = getCommandHistoryStorage(state);
  var sessionWrapper = getDashboardSessionWrapper(state, ownProps.localDashboardId);
  var _ref2 = sessionWrapper !== null && sessionWrapper !== void 0 ? sessionWrapper : {},
    session = _ref2.session,
    sessionConfig = _ref2.config;
  var _ref3 = sessionConfig !== null && sessionConfig !== void 0 ? sessionConfig : {},
    language = _ref3.type,
    sessionId = _ref3.id;
  return {
    commandHistoryStorage,
    language,
    session,
    sessionId
  };
};
var ConnectedCommandHistoryPanel = connect(mapStateToProps, null, null, {
  forwardRef: true
})(CommandHistoryPanel);
export default ConnectedCommandHistoryPanel;
//# sourceMappingURL=CommandHistoryPanel.js.map